"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGE = 'errorMessage';
exports.ERROR_CODE = 'errorCode';
exports.CUSTOMER_ID = 'customerId';
exports.OPERATION_ID = 'operationId';
exports.ORDER_ID = 'orderId';
exports.LANDING_PAGE_URL = '/';
exports.OPERATIONS_URL = '/operations';
